import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { usePlans, POPULAR_PID } from "@/hooks/usePlans";

export const QuickPlans = () => {
  const plans = usePlans();
  return (
    <div data-testid="quick-plans" className="relative mx-auto max-w-[1400px] px-5 sm:px-10 pt-6 sm:pt-10 pb-14 sm:pb-20">
      <p className="mb-4 flex items-center gap-2 text-xs tracking-[0.3em] text-zinc-400"><ArrowDown className="h-3.5 w-3.5" />ACESSO RÁPIDO AOS PLANOS</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {plans.map((p, i) => (
          <motion.a
            key={p.pid}
            data-testid={`quick-plan-${p.pid}`}
            href={`#plano-${p.pid}`}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.1 + i * 0.07, duration: 0.6 }}
            whileHover={{ y: -4 }}
            className={`group flex flex-col gap-1 rounded-2xl border px-4 py-3.5 backdrop-blur-md transition-colors ${p.pid === POPULAR_PID ? "border-cyan-300/50 bg-cyan-300/[0.08]" : "border-white/10 bg-white/[0.04] hover:border-white/25"} ${i === 4 ? "col-span-2 sm:col-span-1" : ""}`}
          >
            <span className="flex items-center justify-between gap-2">
              <span className="text-xs font-semibold tracking-[0.2em] text-zinc-400 whitespace-nowrap">OPÇÃO {p.pid}</span>
              <span className="truncate text-xs text-zinc-300">{p.tag}</span>
            </span>
            <span className="font-display text-xl font-black whitespace-nowrap">R$ {p.price}</span>
          </motion.a>
        ))}
      </div>
    </div>
  );
};
